import React from 'react';
import { ShieldCheck, ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-sky-50 pt-8 pb-12 md:pt-16 md:pb-20 lg:pt-20 lg:pb-24 overflow-hidden border-b border-sky-100" data-id="element-58">
      <div className="absolute inset-0 bg-blue-600/5 rounded-full blur-3xl opacity-50 -top-24 -left-24 w-96 h-96" data-id="element-59"></div>
      <div className="absolute inset-0 bg-amber-400/5 rounded-full blur-3xl opacity-50 top-1/2 right-0 w-96 h-96" data-id="element-60"></div>
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-62">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-blue-700 font-medium text-xs sm:text-sm mb-4 sm:mb-6 border border-blue-100" data-id="element-63">
            <ShieldCheck className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-64" />
            <span data-id="element-65">Pensado para consultorio en Argentina</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-6 sm:mb-8 leading-tight" data-id="element-66">
            Ordená tu Consulta de Psicología Infanto-Juvenil en{' '}
            <span className="text-blue-600" data-id="element-67">7 Días</span>
          </h1>

          {/* Mockup — shown at 70% of its native (1:1) size */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="mx-auto w-[70%] max-w-[717px]" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/wzifXFnaptypwEX47kHkQe/salud_mental_pediatrica.webp" alt="Atlas visual del Megapack de Salud Mental Pediátrica — tomos y planillas clínicas" width={1024} height={1024} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto" data-id="element-69" />
          </motion.div>

          {/* Small caption under the mockup */}
          <p className="text-[11px] sm:text-xs text-slate-500 font-medium tracking-wide mb-6 sm:mb-8" data-id="element-70">
            Guía Profesional y Herramientas Clínicas — Infancia y Adolescencia
          </p>

          <p className="text-sm sm:text-base text-slate-600 mb-6 sm:mb-8 max-w-2xl mx-auto" data-id="element-71">
            Protocolos de evaluación, guiones de entrevista familiar,
            intervención en ansiedad, depresión, trauma y apego, modelos de
            informe clínico y herramientas de regulación emocional — todo listo
            para descargar y aplicar desde tu próxima sesión. Sin armar nada
            desde cero.
          </p>

          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 sm:gap-x-6 sm:gap-y-3 mb-8 sm:mb-10" data-id="element-72">
            {['PDF Digital', 'Acceso Inmediato', 'Garantía 7 días', 'Pago seguro · Mercado Pago'].map((item, i) => <motion.li initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} key={i} className="flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base text-slate-700 font-medium" data-id="element-73">
                <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 flex-shrink-0" data-id="element-74" />
                {item}
              </motion.li>)}
          </ul>

          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="#oferta" className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg shadow-blue-600/30" data-id="element-75">
            QUIERO ORDENAR MI CONSULTA AHORA
            <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5" data-id="element-76" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}